/**
 * Load runtime Stripe + Maps config before any other app code. Ensures /hq-stripe-config.js
 * (written by docker-entrypoint-nginx.sh) runs before components read window.__REACT_APP_* keys.
 *
 * Always same-origin: hq-stripe-config.js is injected at nginx container start, not on CDN.
 */
function stripeConfigScriptHref() {
  return '/hq-stripe-config.js';
}

const s = document.createElement('script');
s.src = stripeConfigScriptHref();
s.async = false;
s.onload = () => {
  import('./bootstrap');
};
s.onerror = () => {
  import('./bootstrap');
};

document.head.appendChild(s);
